import { useEffect, useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { useRemoveGalleryImg } from "../../apis/Member";
import CustomModal from "../popups/customModal";

const GallerySlider = ({ selectedImg, setSelectedImg, data, index }) => {
  const { REACT_APP_IMG_URL } = process.env;
  const [slides, setSlides] = useState([]);
  const [currentImg, setCurrentImg] = useState(-1);
  const [showConfirm, setShowConfirm ] = useState(false);
   const { mutate, isLoading, error } = useRemoveGalleryImg();


  useEffect(() => {
    const tempArr = data.map((d, i) => ({
      ...d,
      src: REACT_APP_IMG_URL + d.large,
      index: i,
    }));

    setSlides(tempArr);
  }, [data, REACT_APP_IMG_URL, selectedImg]);

  const deleteImage = (i) => {
    const selectedImg = slides.filter((img) => i == img.index);
    mutate(selectedImg[0].id);
    setSelectedImg(-1); // Close the Lightbox after deletion
    setShowConfirm(false);
  };

  return (
    <>
      <Lightbox
        toolbar={{
          buttons: [
            <button
              key="delete_btn"
              type="button"
              className="yarl__button"
              onClick={() => {setShowConfirm(true); setSelectedImg(-1);}}
            >
              <i className="fa-solid fa-trash"></i>
            </button>,
            <button key="close_btn" type="button" className="yarl__button" />,
            "close",
          ],
        }}
        on={{ view: ({ index: currentIndex }) => setCurrentImg(currentIndex) }}
        open={selectedImg >= 0}
        index={index}
        slides={slides}
        close={() => setSelectedImg(-1)}
      />
      <CustomModal
        isTimer={false}
        show={showConfirm}
        type={1}
        showBtn={true}
        btnFn={()=>deleteImage(currentImg)}
        btnTxt={"btn.confirm"}
        onShow={setShowConfirm}
        message={"profile.txt26"}
        
      />
    </>
  );
};

export default GallerySlider;
